var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRequestLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M15.833 2.4a2.267 2.267 0 1 1 0 4.533 2.267 2.267 0 0 1 0-4.533ZM10.834 2.4c.791 0 1.433.642 1.433 1.433V5.5c0 .792-.642 1.433-1.433 1.433h-7.5A1.433 1.433 0 0 1 1.9 5.5V3.833c0-.791.642-1.433 1.434-1.433h7.5ZM15.833 8.233a2.267 2.267 0 1 1 0 4.534 2.267 2.267 0 0 1 0-4.534ZM10.834 8.233c.791 0 1.433.642 1.433 1.434v1.666c0 .792-.642 1.434-1.433 1.434h-7.5A1.433 1.433 0 0 1 1.9 11.333V9.667c0-.792.642-1.434 1.434-1.434h7.5ZM15.833 14.067a2.267 2.267 0 1 1 0 4.533 2.267 2.267 0 0 1 0-4.533ZM10.834 14.067c.791 0 1.433.641 1.433 1.433v1.667c0 .791-.642 1.433-1.433 1.433h-7.5A1.433 1.433 0 0 1 1.9 17.167V15.5c0-.792.642-1.433 1.434-1.433h7.5Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestLight);
export default __webpack_public_path__ + "static/media/request-light.d37bc97833fb9c738c2af6209eb39e91.svg";
export { ForwardRef as ReactComponent };